import { Link } from "react-router-dom";
import { RevueNumerique } from "../../lib/interfaces/revue-numerique.interface";
import Box from "../ui/Box";
import { Button } from "../ui/button";
import { Eye } from "lucide-react";

export default function RevueNumeriqueItem({ revue }: { revue: RevueNumerique }) {
  return (
    <Box className='max-w-[630px]'>
      <div className='flex flex-row gap-5'>
        <div className='w-[130px]'>
          <img src={revue.couvertureUrl} alt={revue.nom} />
        </div>
        <div className='flex flex-col gap-2'>
          <p className='text-lg font-bold text-slate-800'>{revue.nom}</p>
          <p className='text-sm text-gray-500'>{revue.description}</p>
          <Link to={`/revue/${revue.id}`}>
            <Button className='w-max'>
              <div className='flex flex-row gap-2 items-center'>
                <Eye />
                <p>Lire la revue</p>
              </div>
            </Button>
          </Link>
        </div>
      </div>
    </Box>
  );
}
